export const firstAdministratorRequiredMessage =
  '이 계정의 소속·사업장 권한 확인이 필요합니다. 사용자 관리에서 승인 상태를 확인해 주세요.';

export const firstAdministratorFirstStep =
  '공장 안전담당자에게 승인된 소속과 사업장 권한을 확인해 주세요. 승인 후에도 같으면 다시 로그인해 주세요.';

function record(value: unknown): Record<string, unknown> | null {
  return typeof value === 'object' && value !== null
    ? (value as Record<string, unknown>)
    : null;
}

/** Legacy helper name retained for callers; missing membership is not proof that bootstrap is absent. */
export function needsFirstAdministrator(error: unknown): boolean {
  const source = record(error);
  const details = record(source?.details);
  const customData = record(source?.customData);
  const customDetails = record(customData?.details);
  const signals = [
    source?.code,
    source?.message,
    details?.code,
    details?.recovery,
    details?.authorityPath,
    customData?.code,
    customData?.message,
    customDetails?.code,
    customDetails?.recovery,
    customDetails?.authorityPath,
  ].map((value) => String(value ?? ''));
  return signals.some(
    (value) =>
      value.includes('SITE_MEMBERSHIP_REQUIRED') ||
      value.includes('TENANT_MEMBERSHIP_REQUIRED') ||
      value.includes('ACCOUNT_SETTINGS_ASSIGNMENT') ||
      value.includes('/siteMemberships/') ||
      value.includes('/tenantMemberships/'),
  );
}

export function administrationFailureMessage(error: unknown, fallback: string): string {
  return needsFirstAdministrator(error) ? firstAdministratorRequiredMessage : fallback;
}
